import { defineStore } from "pinia";
import { apiCall } from "../../utils/api";

export const useCardFragmentStore = defineStore("cardFragment", {
  state: () => ({
    fragments: [],
  }),
  getters: {
    fragmentObj: (state) => {
      const rtn = {};
      state.fragments.forEach((item) => {
        rtn[item.id] = item.name;
      });
      return rtn;
    },
  },
  actions: {
    async getAll(force = false) {
      if (force || this.fragments.length === 0) {
        const response = await apiCall("card.getFragments", {});
        if (!response) {
          return false;
        }
        this.fragments = response;
      }

      return true;
    },
  },
});
